/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  ListUserPreferencesParams,
  PaginatedUserPreferences,
  UpdateUserPreferenceBody
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient';
import type { ErrorType } from '../../../internalAxiosClient';
import { customQueryOptions } from '../../../customQueryOptions';




/**
 * @summary List of User Preferences
 */
export const listUserPreferences = (
    params?: MaybeRef<ListUserPreferencesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedUserPreferences>(
      {url: `/user_preferences`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListUserPreferencesQueryKey = (params?: MaybeRef<ListUserPreferencesParams>,) => {
    return ['user_preferences', ...(params ? [params]: [])] as const;
    }

    
export const useListUserPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<void>>(params?: MaybeRef<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListUserPreferencesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserPreferences>>> = ({ signal }) => listUserPreferences(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData> 
}

export type ListUserPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listUserPreferences>>>
export type ListUserPreferencesQueryError = ErrorType<void>


/**
 * @summary List of User Preferences
 */

export function useListUserPreferences<TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListUserPreferencesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}



/**
 * @summary Update/Create User Preference
 */
export const updateUserPreference = (
    updateUserPreferenceBody: MaybeRef<UpdateUserPreferenceBody>,
 signal?: AbortSignal
) => {
      updateUserPreferenceBody = unref(updateUserPreferenceBody);
      
      return axiosClient<void>(
      {url: `/user_preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserPreferenceBody, signal
    },
      );
    }
  


export const getUpdateUserPreferenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext> => {
    
const mutationKey = ['updateUserPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserPreference>>, {data: UpdateUserPreferenceBody}> = (props) => {
          const {data} = props ?? {};

          return  updateUserPreference(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPreference>>>
    export type UpdateUserPreferenceMutationBody = UpdateUserPreferenceBody
    export type UpdateUserPreferenceMutationError = ErrorType<void>

    /**
 * @summary Update/Create User Preference
 */
export const useUpdateUserPreference = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserPreference>>,
        TError,
        {data: UpdateUserPreferenceBody},
        TContext
      > => {

      const mutationOptions = getUpdateUserPreferenceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    